import React from "react";
import moment, { Moment } from "moment";
import Datetime from "react-datetime";
import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CONSTANTS } from "@constants/index";
import { CustomDatePickerProps } from "@models/components/formElements.model";

import "react-datetime/css/react-datetime.css";

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  className,
  control,
  errors,
  id,
  isValidDate,
  label,
  name,
  registerOptions,
  ...rest
}) => {
  const {
    field: { ref, ...inputProps },
  } = useController({
    control,
    defaultValue: "",
    name,
    rules: { ...registerOptions[name] },
  });

  const { t } = useTranslation();

  const handleChange = (value: Moment | string) => {
    const parsedDate = parseDate(value);
    if (parsedDate.isValid()) {
      inputProps.onChange(
        moment(value).format(CONSTANTS.DATE_FORMATS.DAY_MONTH_YEAR_FORMAT)
      );
    }
  };

  const parseDate = (value: Moment | string) => {
    return moment(value, CONSTANTS.DATE_FORMATS.DAY_MONTH_YEAR_FORMAT, true);
  };

  return (
    <>
      <Datetime
        {...inputProps}
        {...rest}
        closeOnSelect
        dateFormat={CONSTANTS.DATE_FORMATS.DAY_MONTH_YEAR_FORMAT}
        inputProps={{
          autoComplete: "off",
          className: className,
          id: id,
          placeholder: t("dateFormat"),
          ref,
          ...inputProps,
        }}
        isValidDate={isValidDate}
        onChange={handleChange}
        timeFormat={false}
      />
      <label htmlFor={name as string}>{label}</label>
      <i className="fa-regular fa-calendar-days" />
      {errors[name] && (
        <div className="invalid-feedback">{errors[name].message}</div>
      )}
    </>
  );
};

export default CustomDatePicker;
